/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="showScoreCard"
    class="row recording-scorecard"
    aria-hidden="true"
    aria-labelledby="scoresheader2"
  >
    <!-- Scores -->
    <div
      v-for="_col in [0, 1, 2]"
      class="form-group col-xs-4"
    >
      <div
        v-for="(score, idx) in unhiddenScorecardQuestionsForRecording"
        v-if="idx % 3 == _col"
        :key="score.label + '_' + score.value"
        class="rating-box box"
      >
        <div v-if="score.isHeader">
          <span
            id="scoresheader2"
          >
            REVIEWED
            <small>
              BY YOUR
              {{ coachOnlyScores ? 'COACH' : 'COACH/PEERS' }}
            </small>
          </span>
        </div>
        <div
          v-else
          aria-hidden="true"
        >
          <span style="font-weight: bold; display: block;">
            {{ score.label }}
          </span>
          <!-- eslint-disable-next-line -->
          <div class="scoreDescription">{{ getScoreText(score) }}</div>
          <star-rating
            inactive-color="#fff"
            :increment="0.5"
            :border-width="1"
            border-color="#cccccc"
            active-color="#EFA042"
            :star-size="15"
            :padding="3"
            :rating="(score.avgScore) ? score.avgScore / 2 : 0"
            :read-only="true"
            :star-points="[ 25,2, 19,20, 0,20, 15,32, 9,50, 25,39, 41,50, 35,32, 50,20, 31,20]"
          />
          <div
            v-if="score.responses"
            class="num-raters"
          >
            from {{ score.responses.length }} rater{{ score.responses.length > 1 ? 's' : '' }}
          </div>
        </div>
        <div
          v-if="score.responses"
          class="sr-only"
        >
          The score for {{ score.label }} is {{ score.avgScore }} out of 10.
          This score is based on ratings from {{ score.responses.length }} rater{{ score.responses.length > 1 ? 's' : '' }}.
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less">
  #scoresheader2 {
    font-size: 11pt;
    font-weight: bold;
    small {
      font-size: 8pt;
    }
  }
  .scoreDescription {
    white-space: pre-line;
    /*
    max-height: 400px;
    overflow-y: scroll;
     */
  }
  .recording-scorecard {
    border-radius: 8px;
    background-color: #f2f2f2;
    padding-top: 5px;
    margin-left: 1px;
  }
  .recording-scorecard span.vue-star-rating-rating-text {
    display: none;
  }
  .num-raters {
    font-size: 8pt;
  }
  .rating-box {
    margin-top: 8px;
  }
</style>

<script>

import StarRating from 'vue-star-rating';
import ScorecardMixin from '../specials/ScorecardMixin';
import util from '../utils/util';

export default {
  components: {StarRating},
  mixins: [ScorecardMixin],
  props: ['recording'],
  computed: {
    isSmallViewport: {
      cache: false,
      get: util.isSmallViewport
    },
    unhiddenScorecardQuestionsForRecording: {
      cache: false,
      get() {
        const sc = this.getScorecardQuestionsForRecording(
          this.recording, this.scorecard
        );

        // Put an item to denote the header row at the start of the array
        let scf = this._.filter(sc, (q) => !q.hidden);
        const header = {isHeader: true, label: 'header', value: 1};
        scf.unshift(header);

        return scf;
      }
    },
  }
};
</script>
